import { render, staticRenderFns } from "./invoice-payment-link.vue?vue&type=template&id=3b7bb75d&scoped=true"
import script from "./invoice-payment-link.vue?vue&type=script&lang=js"
export * from "./invoice-payment-link.vue?vue&type=script&lang=js"
import style0 from "./invoice-payment-link.vue?vue&type=style&index=0&id=3b7bb75d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7bb75d",
  null
  
)

export default component.exports